export const RENT_PAGE = '/Wynajem'

export const MAIN_PAGE = '/'

export const REALISATION_PAGE = '/Realizacje'

export const STUDIO_PAGE = '/Studio'

export const CONTACT_PAGE = '/Kontakt'

export const SOCIAL_MEDIA = '/SocialMedia'

export const COMPANIES_PAGE = '/DlaFirm'

export const COMPANIES_LONG_TERM_RENT = `${COMPANIES_PAGE}/Najem`
export const COMPANIES_SERVICES = `${COMPANIES_PAGE}/Uslugi`

/** Offer list entry point — `/Wynajem/Wybor | Sprzet-DJ | Sprzet-Sceniczny`. */
export const RENT_LIST_PAGE = `${RENT_PAGE}/Wybor`

/**
 * Single product detail. Kept on its own segment so it can never collide with
 * the offer list category slugs.
 */
export const PRODUCT_PAGE = `${RENT_PAGE}/Produkt`
